
<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Remover usuário"
      message="Você tem certeza que deseja deletar esse usuário?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="users"
        :options.sync="options"
        :server-items-length="total"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhum usuário encontrado"
        :footer-props=" {
          showFirstLastPage: true,
          'items-per-page-text': 'registros por página',
          'items-per-page-options': optionsPage,
          pageText: '{0}-{1} de {2}'
        }"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Usuários</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openNewUserModal"
                >
                  Novo Usuário
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="user.name"
                            :rules="requiredRules"
                            label="Nome"
                            maxlength="100"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            label="E-mail"
                            v-model="user.email"
                            :rules="emailRules"
                            maxlength="100"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            type="password"
                            v-model="user.password"
                            :rules="createdRequiredRules"
                            label="Senha"
                            maxlength="100"
                            required
                          />
                        </v-col>
                        <v-col v-if="isAdmin" cols="12" sm="6" md="4">
                          <v-select
                            v-model="user.role"
                            item-text="name"
                            item-value="id"
                            no-data-text="Sem dados"
                            :items="rolesItems"
                            :rules="requiredRules"
                            label="Papel"
                            required
                            :disabled="!modeCreate"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-mask="'(##) #####-####'"
                            label="Telefone Celular"
                            v-model="user.cell"
                            :rules="requiredRules"
                            required
                          />
                        </v-col>
                        <v-col v-if="[2, 3].includes(user.role)" cols="12" sm="6" md="4">
                          <v-text-field
                            v-mask="user.role === 3 ? 'XX.XXX.XXX/XXXX-##' : '###.###.###-##'"
                            v-model="user.cpfCnpj"
                            :rules="user.role === 3 ? cnpjRules : cpfRules"
                            :label="user.role === 3 ? 'CNPJ' : 'CPF'"
                            required
                            @keyup="uppercase"
                            :disabled="isMe"
                          />
                        </v-col>
                        <v-col v-if="isAdmin && isBrokerUser" cols="12" sm="6" md="4">
                          <v-select
                            v-model="user.realState"
                            item-text="name"
                            item-value="id"
                            :items="realStateItems"
                            :rules="realStateRule"
                            label="Imobiliária"
                            no-data-text="Sem dados"
                            required
                            :disabled="!modeCreate"
                          />
                        </v-col>
                        <!-- <v-col v-if="user.role === 2 && user.realState && modeCreate" cols="12" sm="6" md="6">
                          <v-file-input
                            class="mr-2 mt-2"
                            v-model="fileImport"
                            label="Excel de importação (.xlsx)"
                          ></v-file-input>
                        </v-col> -->
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" :disabled="!valid" text @click="validate">Salvar</v-btn>
                  <!-- <v-btn :disabled="!canImportBrokers" color="gray darken-1" text @click="importExcel"> Importar</v-btn> -->
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogImport" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green"
                  dark
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Importar
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Importar usuários</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="formImport"
                      v-model="validImport"
                      lazy-validation
                    >
                      <v-row>
                        <v-col v-if="isAdmin" cols="12" sm="6" md="4">
                          <v-select
                            v-model="fileImport.realState"
                            item-text="name"
                            item-value="id"
                            :items="realStateItems"
                            :rules="requiredRules"
                            label="Imobiliária"
                            no-data-text="Sem dados"
                            required
                            hint="Selecione a Imobiliária"
                            persistent-hint
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-file-input
                            class="mr-2 mt-2"
                            v-model="fileImport.file"
                            label="Excel de importação (.xlsx)"
                            hint="Selecione o arquivo de importação"
                            :rules="fileRules"
                            accept=".xlsx"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="closeImport">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!validImport" text @click="validateImport">Importar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-btn v-if="isAdmin" color="green" dark class="mb-2 mr-2" v-on:click="exportExcel">
              Exportar
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col v-if="isAdmin" cols="12" sm="4" md="3">
                <v-select
                  :items="realStateItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Imobiliária"
                  v-model="filters.realState"
                />
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field
                  label="Nome"
                  v-model="filters.name"
                />
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="green" class="btn-filter" text @click="filterUsers">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="1">
                <v-btn color="red" class="btn-filter" text @click="clearFilters">Limpar Filtros</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`item.username`]="{ item }">
          <p v-if="item.username">{{item.username}}</p>
          <p v-if="!item.username">-</p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="edit(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            small
            @click="openConfirmModal(item)"
          >
            mdi-delete-empty
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2"></div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'
import store from '@/store'
import { isCPF, isCNPJ } from 'brazilian-values'
import jsonxlsx from 'json-as-xlsx'
import xlsx from 'xlsx'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    optionsPage: [10, 25, 50, 100],
    confirmModal: false,
    hasSure: false,
    itemToDelete: null,
    dialog: false,
    dialogImport: false,
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    validImport: true,
    requiredRules: [
      v => !!v || 'Informação obrigatória'
    ],
    emailRules: [
      v => !!v || 'Informação obrigatória',
      v => /.+@.+/.test(v) || 'E-mail deve ser válido'
    ],
    cpfRules: [
      v => !!v || 'Informação obrigatória',
      v => isCPF(v) || 'CPF deve ser válido'
    ],
    cnpjRules: [
      v => !!v || 'Informação obrigatória',
      v => isCNPJ(v) || 'CNPJ deve ser válido'
    ],
    fileRules: [
      v => !!v || 'Arquivo obrigatório',
      v => !v || v.name.endsWith('.xlsx') || 'Arquivo deve ser do tipo .xlsx'
    ],
    users: [],
    rolesItems: [],
    realStateItems: [],
    editedIndex: -1,
    editedId: false,
    user: {
      id: null,
      name: null,
      email: null,
      password: null,
      cpfCnpj: null,
      role: null,
      cell: null,
      realState: null
    },
    defaultItem: {
      id: null,
      name: null,
      email: null,
      password: null,
      cpfCnpj: null,
      role: null,
      cell: null,
      realState: null
    },
    filters: {
      realState: null,
      name: null
    },
    fileImport: {
      file: null,
      realState: null
    }
  }),

  computed: {
    modeCreate () {
      return this.editedIndex === -1
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Usuário' : 'Editar Usuário'
    },
    createdRequiredRules () {
      return this.editedIndex === -1 ? [v => !!v || 'Informação obrigatória'] : []
    },
    isBrokerUser () {
      return (this.user.role && [2, 3].includes(this.user.role.id)) || ([2, 3].includes(this.user.role))
    },
    realStateRule () {
      return this.isBrokerUser ? [v => !!v || 'Informação obrigatória'] : []
    },
    canImportBrokers () {
      return (this.fileImport !== null && typeof this.fileImport !== 'undefined') && this.user.realState !== null && this.user.role === 2 && this.modeCreate
    },
    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    },
    isManager () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 3
    },
    isMe () {
      return store.getters.user.userType !== null && store.getters.user.id === this.user.id
    },
    headers () {
      return [
        { text: 'Nome', align: 'start', value: 'name' },
        { text: 'E-mail', value: 'email' },
        { text: this.isAdmin ? 'CPF/CNPJ' : 'CPF', value: 'cpf_cnpj' },
        { text: 'Ações', value: 'actions', sortable: false }
      ]
    }
  },

  watch: {
    options: {
      handler () {
        this.getUsers()
      },
      deep: true
    },
    dialog (val) {
      val || this.close()
    },
    dialogImport (val) {
      val || this.closeImport()
    }
  },

  created () {
    // this.getUsers()
    if (this.isAdmin) {
      this.getRoles()
      this.getRealStates()
    }
  },

  methods: {
    async getRealStates () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')
        this.realStateItems = data.data
      } catch (error) {
        message.error('Erro ao buscar imobiliárias')
      }
    },

    uppercase () {
      this.user.cpfCnpj = this.user.cpfCnpj ? this.user.cpfCnpj.toUpperCase() : null
    },

    filterUsers () {
      this.options.page = 1
      this.getUsers()
    },

    clearFilters () {
      this.filters.realState = null
      this.filters.name = null
      this.options.page = 1

      this.getUsers()
    },

    validateImport () {
      if (this.$refs.formImport.validate()) {
        this.importExcel()
      }
    },

    importExcel () {
      try {
        if (this.fileImport.file.name.split('.').pop() !== 'xlsx') {
          return message.error('Arquivo não possui extensão .xlsx')
        }

        let fileReader = new FileReader()
        fileReader.readAsBinaryString(this.fileImport.file)
        fileReader.onload = (event) => {
          let data = event.target.result
          let workbook = xlsx.read(data, { type: 'binary' })

          workbook.SheetNames.forEach(sheet => {
            let rows = xlsx.utils.sheet_to_row_object_array(workbook.Sheets[sheet])
            let hasError = false

            for (let row of rows) {
              row.role = this.isAdmin ? row.role : 2

              if (row.name === undefined || row.email === undefined || row.cell === undefined || row.password === undefined || row.identity === undefined || row.role === undefined) {
                message.error('Arquivo fora do padrão')
                hasError = true
                break
              }

              if (row.identity) row.identity = row.identity.toString().toUpperCase()
              if (row.cell) row.cell = row.cell.toString()
              if (row.password) row.password = row.password.toString()
            }

            if (hasError) return

            this.createUsersLot(rows)
          })
        }
      } catch (error) {
        message.error('Erro ao ler Excel para realizar o upload')
      }
    },

    async createUsersLot (users) {
      try {
        this.loadingMessage = 'Carregando'
        this.loading = true
        message.warning('Em execução', 'Usuários sendo importados')

        const realState = this.isAdmin ? this.fileImport.realState : store.getters.user.realState.id

        await api.post('/users/lots', {
          users,
          realState: realState
        })

        message.success('Usuários importados')
        this.closeImport()
        await this.getUsers()
      } catch (error) {
        this.loading = false
        this.closeImport()
        message.error(error.message)
      }
    },

    async exportExcel () {
      try {
        const { data } = await api.get(`/users?page=-1&itemsPerPage=-1`)

        const dataExcel = [{
          sheet: 'Lista',
          columns: [
            { label: 'Nome', value: 'name' },
            { label: 'E-mail', value: 'email' },
            { label: 'Celular', value: 'cell' },
            { label: this.isAdmin ? 'CPF/CNPJ' : 'CPF', value: row => row.cpf_cnpj ? row.cpf_cnpj : '' },
            { label: 'Imobiliária', value: row => row.realState ? row.realState.name : '' }
          ],
          content: data.data
        }]

        const settings = {
          fileName: 'Usuários',
          extraLength: 3,
          writeOptions: {}
        }

        jsonxlsx(dataExcel, settings)
      } catch (error) {
        message.error(error.message)
      }
    },

    async getUsers () {
      try {
        this.loading = true

        let url = `/users?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}`
        if (this.filters.name) url += `&name=${this.filters.name}`
        if (this.filters.realState) url += `&realState=${this.filters.realState}`

        const { data } = await api.get(url)

        this.users = data.data
        this.total = Number(data.total)
      } catch (error) {
        message.error('Erro ao buscar usuários')
      } finally {
        this.loading = false
      }
    },

    getRoles () {
      this.rolesItems = [
        {
          id: 1,
          name: 'Administrador'
        },
        {
          id: 2,
          name: 'Corretor'
        },
        {
          id: 3,
          name: 'Gestor'
        }
      ]
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async edit (item) {
      this.loadingMessage = 'Carregando'
      this.loading = true
      this.editItemToTable(item)
      this.loading = false
    },

    editItemToTable (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedId = item.id
      this.user = Object.assign({}, {
        ...item,
        role: item.role ? item.role.id : null,
        cpfCnpj: item.cpf_cnpj,
        realState: item.realState ? item.realState.id : null
      })
      this.dialog = true
    },

    async deleteItem () {
      if (this.hasSure) {
        this.loadingMessage = 'Removendo'
        this.loading = true

        try {
          await api.delete(`/users/${this.itemToDelete.id}`)
          this.removeToTable(this.itemToDelete)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    openNewUserModal () {
      if (this.isManager) {
        this.user.role = 2
      }
    },

    openConfirmModal (item) {
      this.itemToDelete = item
      this.confirmModal = true
    },

    handleCancelConfirmModal () {
      this.hasSure = false
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.hasSure = true
      this.confirmModal = false
      this.deleteItem()
    },

    removeToTable (item) {
      const index = this.users.indexOf(item)
      this.users.splice(index, 1)
    },

    close () {
      this.$refs.form.reset()
      this.valid = true
      this.dialog = false
      this.$nextTick(() => {
        this.user = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeImport () {
      this.$refs.formImport.reset()
      this.validImport = true
      this.dialogImport = false
      this.$nextTick(() => {
        this.fileImport = Object.assign({}, {
          file: null,
          realState: null
        })
      })
    },

    async save () {
      let data = {
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        cell: this.user.cell,
        cpf_cnpj: this.user.role !== 1 && this.user.cpfCnpj ? this.user.cpfCnpj.toUpperCase() : null,
        real_state_id: this.isAdmin ? this.user.realState : store.getters.user.realState.id,
        role_id: this.isAdmin ? this.user.role : 2
      }

      this.loading = true

      if (this.editedIndex === -1) {
        this.loadingMessage = 'Salvando'

        try {
          const response = await api.post('/users', data)
          message.success('Usuário salvo')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      } else {
        this.loadingMessage = 'Atualizando'

        try {
          const response = await api.put(`/users/${this.editedId}`, data)
          message.success('Usuário atualizado')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    addToTable (item) {
      if (this.editedIndex > -1) {
        Object.assign(this.users[this.editedIndex], this.user)
      } else {
        this.users.push(item)
      }
      this.close()
    }
  }
}
</script>

<style scoped>
  .btn-filter {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue